import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout/DashboardLayout';
import './TasksPage.css';

const TasksPage = () => {
    return (
        <DashboardLayout>
            <div className="tasks-page">
                <h1>Aufgaben</h1>
                <p>Tasks management coming soon...</p>
            </div>
        </DashboardLayout>
    );
};

export default TasksPage;